// Detection mirrors chromatic/isChromatic; inlined so packages/core keeps no Chromatic dependency.
function isChromaticCapture(): boolean {
    return (
        typeof window !== "undefined" &&
        (/Chromatic/.test(window.navigator.userAgent) || /chromatic=true/.test(window.location.href))
    );
}

export const SnapshotConfig = {
    animationsDisabled: false,
    deterministic: isChromaticCapture(),
    deterministicNow: "2026-05-04T00:00:00.000Z"
};
